import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getMeetingsWithAttachments, getMeetingAttachments, storeMeetingAttachments, deleteAttachment } from "src/models/Attachment";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import { downloadFile } from "src/functions/download-file-from-server";
import { commitPagination, hasNextPage } from "src/store/utils/pagination"; // Init state

var initState = function initState() {
  return {
    allMeetingsAndAttachments: {
      data: [],
      meta: null
    },
    meetingAttachments: [],
    attachmentsPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreAttachments: true,
    loading: {
      attachments: false,
      meetingAttachments: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setAllMeetingsAndAttachments: function setAllMeetingsAndAttachments(state, payload) {
    state.allMeetingsAndAttachments = payload;
  },
  appendMeetingsAndAttachments: function appendMeetingsAndAttachments(state, payload) {
    var existingIds = new Set(state.allMeetingsAndAttachments.data.map(function (item) {
      return item.id;
    }));
    var newItems = payload.filter(function (item) {
      return !existingIds.has(item.id);
    });
    state.allMeetingsAndAttachments = _objectSpread(_objectSpread({}, state.allMeetingsAndAttachments), {}, {
      data: [].concat(_toConsumableArray(state.allMeetingsAndAttachments.data), _toConsumableArray(newItems))
    });
  },
  updateAttachmentsPagination: function updateAttachmentsPagination(state, pagination) {
    state.attachmentsPagination.currentPage = pagination.currentPage;
    state.attachmentsPagination.total_pages = pagination.total_pages;
  },
  setHasMoreAttachments: function setHasMoreAttachments(state, value) {
    state.hasMoreAttachments = value;
  },
  setAttachmentsLoading: function setAttachmentsLoading(state, payload) {
    state.loading.attachments = payload;
  },
  setMeetingAttachments: function setMeetingAttachments(state, payload) {
    state.meetingAttachments = payload;
  },
  setMeetingAttachmentsLoading: function setMeetingAttachmentsLoading(state, payload) {
    state.loading.meetingAttachments = payload;
  },
  removeAttachment: function removeAttachment(state, id) {
    var index = state.attachments.findIndex(function (item) {
      return item.id === id;
    });
    state.attachments.splice(index, 1);
  },
  removeMeetingAttachment: function removeMeetingAttachment(state, id) {
    var index = state.meetingAttachments.findIndex(function (item) {
      return item.id === id;
    });
    state.meetingAttachments.splice(index, 1);
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  fetchAllMeetingsAndAttachments: function fetchAllMeetingsAndAttachments(_ref) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, group, _response$data, _response$data2, _response$data3, _response$data3$meta, response, normalizedPayload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit("setAttachmentsLoading", true);
              commit("setHasMoreAttachments", true);
              group = _this.getters["Group/group"];
              _context.prev = 4;
              _context.next = 7;
              return getMeetingsWithAttachments(group.id, 1);

            case 7:
              response = _context.sent;
              normalizedPayload = {
                data: Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) ? response.data.data : Array.isArray(response.data) ? response.data : [],
                meta: ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.meta) || null
              };
              commit("setAllMeetingsAndAttachments", normalizedPayload);
              commitPagination(commit, (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$meta = _response$data3.meta) === null || _response$data3$meta === void 0 ? void 0 : _response$data3$meta.pagination, {
                update: "updateAttachmentsPagination",
                setHasMore: "setHasMoreAttachments"
              });
              commit("setAttachmentsLoading", false);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context.t0));
              commit("setAttachmentsLoading", false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }))();
  },
  fetchMoreAttachments: function fetchMoreAttachments(_ref2) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, group, nextPage, _response$data4, _response$data5, _response$data5$meta, response;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state;
              group = _this2.getters["Group/group"];

              if (!state.loading.attachments) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              if (hasNextPage(state, "attachmentsPagination")) {
                _context2.next = 7;
                break;
              }

              commit("setHasMoreAttachments", false);
              return _context2.abrupt("return");

            case 7:
              commit("setAttachmentsLoading", true);
              nextPage = state.attachmentsPagination.currentPage + 1;
              _context2.prev = 9;
              _context2.next = 12;
              return getMeetingsWithAttachments(group.id, nextPage);

            case 12:
              response = _context2.sent;
              commit("appendMeetingsAndAttachments", Array.isArray((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.data) ? response.data.data : []);
              commitPagination(commit, (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$meta = _response$data5.meta) === null || _response$data5$meta === void 0 ? void 0 : _response$data5$meta.pagination, {
                update: "updateAttachmentsPagination",
                setHasMore: "setHasMoreAttachments"
              });
              commit("setAttachmentsLoading", false);
              _context2.next = 22;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](9);
              errorDialog.showErrorMessageFromServer(getErrorPayload(_context2.t0));
              commit("setAttachmentsLoading", false);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9, 18]]);
    }))();
  },
  fetchMeetingAttachments: function fetchMeetingAttachments(_ref3) {
    var commit = _ref3.commit;
    commit("setMeetingAttachmentsLoading", true);
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve) {
      getMeetingAttachments(group.id, meeting.id).then(function (response) {
        commit("setMeetingAttachments", response.data.data);
        commit("setMeetingAttachmentsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        commit("setMeetingAttachmentsLoading", false);
      });
    });
  },
  createMeetingAttachments: function createMeetingAttachments(_ref4, request) {
    var commit = _ref4.commit;
    var group = this.getters["Group/group"];
    var meeting = this.getters["Meeting/meeting"];
    return new Promise(function (resolve, reject) {
      storeMeetingAttachments(group.id, meeting.id, request).then(function () {
        resolve();
      }).catch(function (e) {
        reject();
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  downloadResource: function downloadResource(_ref5, attachment) {
    var commit = _ref5.commit;
    var group = this.getters["Group/group"];
    var url = "/groups/" + group.id + "/attachments/" + attachment.id + "/download";
    var fileName = attachment.name;
    downloadFile(url, fileName);
  },
  removeMeetingAttachment: function removeMeetingAttachment(_ref6, attachment) {
    var commit = _ref6.commit;

    if (_.isEmpty(attachment.id)) {
      commit("removeNewMeetingAgendaItemAttachment", attachment);
    } else {
      var group = this.getters["Group/group"];
      commit("setMeetingAttachmentsLoading", true);
      return new Promise(function (resolve) {
        deleteAttachment(group.id, attachment.id).then(function () {
          commit("removeMeetingAttachment", attachment.id);
          commit("setMeetingAttachmentsLoading", false);
          resolve();
        }).catch(function (e) {
          errorDialog.showErrorMessageFromServer(getErrorPayload(e).message);
          commit("setMeetingAttachmentsLoading", false);
        });
      });
    }
  },
  removeAttachment: function removeAttachment(_ref7, attachmentId) {
    var commit = _ref7.commit;
    var group = this.getters["Group/group"];
    commit("setMeetingAttachmentsLoading", true);
    return new Promise(function (resolve) {
      deleteAttachment(group.id, attachmentId).then(function () {
        commit("setMeetingAttachmentsLoading", false);
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e).message);
        commit("setMeetingAttachmentsLoading", false);
      });
    });
  }
}; // Getter functions

var getters = {
  allMeetingsAndAttachments: function allMeetingsAndAttachments(state) {
    return state.allMeetingsAndAttachments;
  },
  hasMoreAttachments: function hasMoreAttachments(state) {
    return state.hasMoreAttachments;
  },
  attachmentsLoading: function attachmentsLoading(state) {
    return state.loading.attachments;
  },
  meetingAttachments: function meetingAttachments(state) {
    return state.meetingAttachments;
  },
  meetingAttachmentsLoading: function meetingAttachmentsLoading(state) {
    return state.loading.meetingAttachments;
  },
  meetingAttachmentLength: function meetingAttachmentLength(state) {
    return state.meetingAttachments.length;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};